import React from 'react';
import styles from './judges.module.scss'
import { ajay, vikas, karan, pankaj, srinivas, sushant, tushar, weng, priyanka } from 'src/assets/images';
export type TJudge = {
    image: string;
    name: React.ReactNode;
    title: React.ReactNode,
    firm: React.ReactNode
}
export default function Judges() {
    const judges: TJudge[] = [
        {
            image: ajay,
            name: <span>Ajay <br /> Jain</span>,
            title: <span className={styles.title}>Founder</span>,
            firm: <strong className={styles.firm}>Silverneedle Ventures</strong>
        },
        {
            image: vikas,
            name: <span>Vikas <br /> Katragadda</span>,
            title: <span className={styles.title}>Operating Partner</span>,
            firm: <strong className={styles.firm}>Naandi Ventures</strong>
        },
        {
            image: srinivas,
            name: <span>Srinivas Rao <br /> Mahankali</span>,
            title: <span className={styles.title}>Advisor</span>,
            firm: <strong className={styles.firm}>Abyro Capital</strong>
        },
        {
            image: priyanka,
            name: <span>Priyanka <br /> Madnani</span>,
            title: <span className={styles.title}>Founding Partner</span>,
            firm: <strong className={styles.firm}>Terex Ventures</strong>
        },
        {
            image: pankaj,
            name: <span>Pankaj <br /> Diwan</span>,
            title: <span className={styles.title}>Founder </span>,
            firm: <strong className={styles.firm}>Idealabs FutureTech Ventures</strong>
        },
        {
            image: weng,
            name: <span>Weng <br /> Him Koh</span>,
            title: <span className={styles.title}>Principal Advisor</span>,
            firm: <strong className={styles.firm}>8ccentrix Holdings</strong>
        },
        {
            image: tushar,
            name: <span>Tushar <br /> Shetty</span>,
            title: <span className={styles.title}>CEO</span>,
            firm: <strong className={styles.firm}>Ideas to Impact Hub</strong>
        },
        {
            image: karan,
            name: <span>Karan <br /> Bahadur</span>,
            title: <span className={styles.title}>Founder</span>,
            firm: <strong className={styles.firm}>Draper Startup House India</strong>
        },
        {
            image: sushant,
            name: <span>Sushant <br /> Gadankush</span>,
            title: <span className={styles.title}>Founder</span>,
            firm: <strong className={styles.firm}>DhanXpert</strong>
        }
    ]
    return (
        <section className={styles.judges}>
            <div className={styles.container}>
                <h2>Investor Panel</h2>
                <div className={styles.judgeList}>
                    {judges.map((item, i: number) => (
                        <div key={i} className={styles.judgeCard}>
                            <img src={item.image} alt="Judge" />
                            {item.name}
                            {item.title}
                            {item?.firm}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
